var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('Header'),(
      _vm._.get(this.$store.state.main, 'selected_menu.media.cover') &&
        !_vm._.get(this.$store.state.main.selected_menu, 'routeParams.singleview')
    )?_c('header-banner'):_vm._e(),_c('router-view'),_c('CookiePolicy'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }